import { Button, ButtonProps } from "@chakra-ui/button";

export const CustomButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button backgroundColor={"primary.400"} color={"white"} {...props}>
      {props.title}
    </Button>
  );
};
